
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import debounce from "lodash/debounce";
import formattedNPWP from "@/app/infrastructures/misc/common-library/FormattedNPWP";
import formatInputFloat from "@/app/infrastructures/misc/common-library/FormatInputFloat";
import {
  DistrictFieldRules,
  getFieldRulesForDistrict,
  formatTaxIdInput,
  validateTaxIdValue,
  resolveDistrictFieldRules
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";
import Tooltip from "@/app/ui/components/tooltip/index.vue";
import { PartnerController } from "@/app/ui/controllers/PartnerController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import ModalAddBank from "./modal-add-bank.vue";
import { PosController } from "@/app/ui/controllers/PosController";
import { RequestListPartner } from "@/data/payload/api/PartnerApiRequest";
import { PosData } from "@/domain/entities/Pos";
import FileAttachment from "./file-attachment.vue";
import formatInputMoney from "@/app/infrastructures/misc/common-library/FormatInputMoney";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { FlagsPermissionPartnerManagement } from "@/feature-flags/flags-permission-partner-management";
import SectionAreaDelivery from "./section-area-delivery.vue";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import SelectPhoneCountry from "../../shipment/booking/component/select-phone-country.vue";

@Options({
  components: {
    Title,
    Tooltip,
    ModalAddBank,
    FileAttachment,
    SectionAreaDelivery,
    SelectPhoneCountry
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      this.setModalSuccess(false);
      next();
    }
  }
})
export default class Add extends Vue {
  props: any = this.$props;

  get getTitle() {
    const name = this.$route.meta?.name;
    const key = name != null ? String(name) : "";
    return key && key.includes(".") ? this.$t(key) : key;
  }

  get phonePrefix() {
    return getPhoneDisplayCode(AccountController.accountData?.countryCode);
  }

  get accountCurrencyPrefix() {
    const cc = AccountController.accountData?.countryCode?.toLowerCase();
    return cc === "my" ? configPrice.MYR?.prefix ?? "RM" : configPrice.IDR?.prefix ?? "Rp";
  }

  get formType() {
    return this.$route.meta.form;
  }

  // add bank midtrans enhancement
  get showAddBank() {
    return PartnerController.showAddBank;
  }
  onShowAddBank(val: boolean) {
    PartnerController.setShowAddBank(val);
  }

  onDeleteBank() {
    PartnerController.deleteBank();
  }

  get configAutoCheckbox() {
    return FlagsMedusa.config_auto_checkbox_cod_pos.isEnabled();
  }

  created() {
    if (this.formType === 'pos' && this.configAutoCheckbox) {
      PartnerController.setAutoCheckBookingCodPartner(this.configAutoCheckbox);
    }
  }

  mounted() {
    this.fetchDistricts("");
    this.filterConsolidators("");
    this.filterConsolidatorsWithoutCode("");
    this.filterSubconsolidators("");
    this.fecthCityListData();
    this.initPhoneCode();
  }

  unmounted() {
    PartnerController.onResetForm();
  }

  // back
  goBack() {
    this.$router.push(`/partner/${this.$route.meta.form}`);
  }

  isEditTerminated = false;
  newPath = "";
  answer = false;

  selectedDistrictCountryCode = "ID";
  private _districtSeq = 0;

  get districtFieldRules(): DistrictFieldRules {
    return getFieldRulesForDistrict(this.selectedDistrictCountryCode, "partner");
  }

  get taxMaxLength(): string {
    return this.districtFieldRules.applyNpwpMask
      ? "20"
      : String(this.districtFieldRules.taxIdMaxLength);
  }

  get taxPlaceholder(): string {
    return this.districtFieldRules.applyNpwpMask
      ? "00.000.000.0-000.000"
      : "Masukan Nomor Pajak";
  }

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  // saving
  openConfirmation = false;
  createConfirmation() {
    this.openConfirmation = true;
  }

  get partnerCity() {
    return this.form.cityExclude.length > 0
      ? this.form.cityExclude.map((city: any) => city.code)
      : undefined;
  }

  get partnerPosBranchCommission() {
    return this.form.typePos === "branch"
      ? Number(this.form.branchCommission?.replace(",", "."))
      : 0;
  }

  get partnerPosAttachFile() {
    return this.formType === 'pos' ? this.form.partnerPosAttachFiles?.filter((item: string) => item) : []
  }

  get partnerPosSaldoDeposit() {
    return this.formType === 'pos' ? Number(this.form.debitBalance?.replaceAll(".", "")) : 0
  }

  get partnerOwnershipId() {
    return this.form.subconsolidators ? this.form.subconsolidators?.id : 0
  }

  transformPartnerAreaDeliveries(partnerAreaDeliveries: any) {
    if (!Array.isArray(partnerAreaDeliveries)) {
      return [];
    }

    return partnerAreaDeliveries.map(item => {
      try {
        const cityCode = item?.cityCode?.code || '';

        const districtCodes = (item.district || []).map((district: any) => {
          return district?.value || district?.code;
        }).filter((code: any) => code && code !== '');

        if (districtCodes.includes("ALL")) {
          return {
            city_code: cityCode,
            district_codes: ["ALL"]
          };
        }

        return {
          city_code: cityCode,
          district_codes: districtCodes
        };
      } catch (error) {
        console.error('Error transforming item:', error, item);
        return {
          city_code: '',
          district_codes: []
        };
      }
    });
  }

  get paramsCreate() {
    return {
      type: this.extractAccountType(),
      version: this.extractAccountType() === "pos" ? "v2" : "v1",
      partnerName: this.form.consolidatorName,
      partnerExternalCode: "",
      partnerAddress: this.form.consolidatorAddress,
      partnerDefaultDistrict: this.form.districts.code,
      partnerContractStart: new Date(this.form.startDate.setUTCHours(24))
        .toISOString()
        .slice(0, 10),
      partnerContractEnd: new Date(this.form.endDate.setUTCHours(24))
        .toISOString()
        .slice(0, 10),
      partnerContactName: this.form.contactName,
      partnerContactJobTitle: this.form.contactLevel,
      partnerContactEmail: this.form.contactEmail,
      partnerContactPhoneNumber: this.form.contactPhones
        .map((phone: any) => phone.no)
        .join(", "),
      partnerBeneficiaryBankName: this.form.bank.bankCode,
      partnerBeneficiaryAccountNumber: this.form.bank.accountNo,
      partnerBeneficiaryAccountName: this.form.bank.accountName,
      partnerBeneficiaryEmail: this.form.bank.accountEmail,
      partnerBeneficialAccountLabel: this.form.bank.bankName,
      partnerPhoneNumber: this.form.phone,
      partnerTaxNumber: this.form.taxNumber,
      partnerParentId: this.form.consolidators.id || undefined,
      partnerCity: this.partnerCity,
      partnerLatitude: this.form.latitude,
      partnerLongitude: this.form.longitude,
      partnerReferrerCode: this.form.referralCode,
      partnerPosType: this.form.typePos,
      partnerPosParentId: this.form.parentPos?.id,
      partnerIsCodDelivery: this.form.partnerIsCodDelivery,
      partnerIsPcu: this.form.partnerIsPcu,
      partnerPosBranchCommission: this.partnerPosBranchCommission,
      partnerPosReverseJourney: this.form.partnerPosReverseJourney.id || 0,
      partnerIsCodBooking: this.form.partnerIsCodBooking,
      partnerPosAttachFiles: this.partnerPosAttachFile,
      partnerPosSaldoDeposit: this.partnerPosSaldoDeposit,
      partnerIsAllowBookVippack: this.form.partnerIsAllowBookVippack,
      partnerOwnershipId: this.partnerOwnershipId,
      partnerAreaDeliveries: this.transformPartnerAreaDeliveries(this.form.partnerAreaDelivery) as any,
      partnerIsPosOwnSales: this.form.partnerIsPosOwnSales,
    }
  }

  openSuccess = false;
  async onCreate() {
    this.openConfirmation = false;
    const response = await PartnerController.addPartner(this.paramsCreate);
    if (this.errorMessageAdd === "Referal Code not found") {
      this.checkReferralCodeResult = false;
      const refs: any = this.$refs;
      refs.formAddPos.scroll({
        top: refs.formAddPos.scrollHeight - refs.formAddPos.offsetHeight,
        behavior: "smooth"
      });
    }
    this.openSuccess = !!response;
  }

  extractAccountType() {
    const route = this.$route.meta.form as string;
    const accounType: any = {
      "consolidator": "console",
      "sub-consolidator": "sub-console"
    }
    
    return accounType[route] ?? "pos"
  }

  get isLoading() {
    return PartnerController.isLoading;
  }

  get isError() {
    return PartnerController.isError;
  }

  get errorCause() {
    return PartnerController.errorCause;
  }

  get openSuccessFromState() {
    return PartnerController.modalSuccess;
  }

  handleError() {
    PartnerController.setIsError(false);
    PartnerController.setErrorCause("");
  }

  onCloseConfirmation() {
    this.openConfirmation = false;
  }

  onCloseSuccess() {
    this.openSuccess = true;
    PartnerController.setModalSuccess(false);
    this.goBack();
  }

  setModalSuccess(value: boolean) {
    PartnerController.setModalSuccess(false);
    this.openSuccess = value;
  }

  //partner name
  get partnerName() {
    if (this.$route.meta.form === "consolidator") {
      return "Nama Consolidator";
    } else if (this.$route.meta.form === "sub-consolidator") {
      return "Nama Sub Consolidator";
    } else {
      return "Nama POS";
    }
  }

  // tooltip
  isOpenTooltipAddCity = false;

  // error
  error = {
    error: false,
    taxNumber: false,
    contactPhone: false,
    contactEmail: false,
    bankEmail: false,
    accountBankNo: false,
    commision: false,
    message: "partnerManagement.error.phoneInvalid",
    phone: false
  };

  // form
  
  get form() {
    return PartnerController.formAdd;
  }

  // districts
  fetchDistricts = debounce((search: string) => {
    LocationController.getDistrictList({
      search: search,
      status: "active",
      page: 1,
      limit: 10,
      cache: true
    });
  }, 250);

  get districts() {
    return LocationController.districtData.districtData.map(e => ({
      id: e.id,
      name: `${e.name}, ${e.cityName}`,
      code: `${e.code}`,
      cityCode: `${e.cityCode}`
    }));
  }

  get isLoadingDistricts() {
    return LocationController.isLoadingDistrict;
  }

  // districts toppings
  get cityOver() {
    if (this.form.cityExclude.length > 5) {
      this.form.cityExclude.pop();
      return true;
    }

    return false;
  }

  get isLoadingCity() {
    return LocationController.isLoading;
  }

  fecthCityListData() {
    LocationController.getCityList({
      search: "",
      status: "",
      page: 1,
      limit: 10
    });
  }

  get cityListData() {
    return LocationController.cityData.cityData.map(e => ({
      code: e.code,
      name: `${e.name}`
    }));
  }

  filterCityList(search: string) {
    if (search.length > 2 || !search) {
      LocationController.getCityList({
        search: search,
        status: "",
        page: 1,
        limit: 10
      });
    }
  }

  onCloseSelectSearchConsolidator() {
    this.filterConsolidators("");
  };

   onCloseSelectSearchConsolidatorWithoutCode() {
    this.filterConsolidatorsWithoutCode("");
  };

  onCloseSelectConsolidatorsByCity() {
    this.form.subconsolidators = "";
    this.form.consolidators = "";
  }

  // subconsolidators
  filterSubconsolidators = debounce((search: string) => {
      PartnerController.getConsolidatorsByCity({
        search: search,
        page: 1,
        limit: 10,
        cityCode: "",
        type: "console",
        status: this.partnerStatus
      });
  }, 250);
  
  // consolidators
  filterConsolidators = debounce((search: string) => {
    if (this.cityCode) {
      PartnerController.getConsolidatorsByCity({
        search: search,
        page: 1,
        limit: 10,
        cityCode: this.cityCode === undefined ? "" : this.cityCode,
        type: !this.partnerType ? "console" : this.partnerType,
        status: this.partnerStatus
      });
    }
  }, 250);

  filterConsolidatorsWithoutCode = debounce((search: string) => {
      PartnerController.getConsolidatorsByCity({
        search: search,
        page: 1,
        limit: 10,
        cityCode: "",
        type: !this.partnerType ? "console" : this.partnerType,
        status: this.partnerStatus
      });
  }, 250);

  get consolidators() {
    if (this.$route.meta.form === "sub-consolidator" && this.form.districts) {
      return PartnerController.consolidatorsByCity.consolidatorByCityData.map(
        e => ({
          id: e.id,
          name: `${e.name}`
        })
      );
    } else if (this.$route.meta.form === "pos") {
      if (this.partnerType) {
        return PartnerController.consolidatorsByCity.consolidatorByCityData.map(
          e => ({
            id: e.id,
            name: `${e.name}`
          })
        );
      }

      return [];
    } else {
      return [];
    }
  }

  get consolidatorConsolePos() {
      return PartnerController.consolidatorsActiveByCity.consolidatorByCityData.map(
        e => ({
          id: e.id,
          name: `${e.name}`
        })
      );
    }

    get consolidatorsWithouCityCode() {
    if (this.$route.meta.form === "sub-consolidator") {
      return PartnerController.consolidatorsByCity.consolidatorByCityData.map(
        e => ({
          id: e.id,
          name: `${e.name}`
        })
      );
    } else if (this.$route.meta.form === "pos") {
      if (this.partnerType) {
        return PartnerController.consolidatorsByCity.consolidatorByCityData.map(
          e => ({
            id: e.id,
            name: `${e.name}`
          })
        );
      }

      return [];
    } else {
      return [];
    }
  }

  get isLoadingConsolidators() {
    return PartnerController.loadingConsolidatorsByCity;
  }

  cityCode = "";
  partnerType = "";
  partnerStatus = "";
  isShowAreaDeliverySection = false;
  citiesList: any[] = [];
  loadingGetCityList = false;

  async fetchCityList(search: string) {
    try {
      this.loadingGetCityList = true;
      const res = await LocationController.getDestinationCities({
        search: search,
        status: "",
        page: 1,
        limit: 10
      });
      this.citiesList = res.data.map((e: any) => ({
        ...e,
        name: `${e.code} - ${e.name}`
      }));
      this.loadingGetCityList = false;
    } catch (error) {
      this.loadingGetCityList = false;
    }
  }

  async showPartnerAreaSection(val: string) {
    const flagValue = FlagsPermissionPartnerManagement.permission_area_delivery_by_3lc_enable.getValue();

    const shouldShow = Array.isArray(flagValue) && flagValue.includes(val);
    if (shouldShow) {
      await this.fetchCityList(val)
      this.form.partnerAreaDelivery = [{
        cityCode: this.citiesList[0],
        district: [{ name: "Semua", code: "ALL" }]
      }];
    }
    this.isShowAreaDeliverySection = shouldShow;
    return this.isShowAreaDeliverySection;
  }
  async onDistrictSelected(districtValue: any): Promise<void> {
    const seq = ++this._districtSeq;
    if (!districtValue || districtValue === "") {
      this.selectedDistrictCountryCode = "ID";
      return;
    }
    const prevCountryCode = this.selectedDistrictCountryCode;
    const rules = await resolveDistrictFieldRules(districtValue, "partner");
    if (seq !== this._districtSeq) {
      return;
    }
    this.selectedDistrictCountryCode = rules.countryCode;
    if (prevCountryCode !== rules.countryCode) {
      this.clearAffectedFieldsOnDistrictSwitch();
    }
  }

  clearAffectedFieldsOnDistrictSwitch(): void {
    this.form.phone = "";
    this.form.taxNumber = "";
    this.form.contactPhones = [{ no: "", error: false }];
    this.form.debitBalance = "";
    this.error.phone = false;
    this.error.taxNumber = false;
  }

  async getConsolidatorsByCity(obj: any) {
    await this.onDistrictSelected(obj);
    this.form.consolidators = "";
    this.form.subconsolidators = "";
    this.errorKecamatanKota = false;
    this.errorCaptionKecamatanKota = "";
    this.form.partnerAreaDelivery = [];
    this.cityCode = obj.cityCode;
    this.showPartnerAreaSection(obj.cityCode);

    PartnerController.getConsolidatorsByCity({
      search: "",
      page: 1,
      limit: 10,
      cityCode: this.cityCode === undefined ? "" : this.cityCode,
      type:
        this.$route.meta.form === "sub-consolidator"
          ? "console"
          : this.partnerType,
      status: this.partnerStatus
    });

    PosController.setDefaultPosList();
    this.form.parentPos = "";
    this.form.partnerPosReverseJourney = "";
    if (this.$route.meta.form !== "pos") {
      this.filterPartnerPosReverseJourney("");
    }
  }
  
  // partners area type
  partnerAreaTypeList = [
    {
      name: "Pilih partner area",
      value: ""
    },
    {
      name: "Consolidator",
      value: "console"
    },
    {
      name: "Sub Consolidator",
      value: "sub-console"
    }
  ];

  isOpenPartnerType = false;
  onOpenSelectPartnerType() {
    this.isOpenPartnerType = true;
  }

  onCloseSelectPartnerType() {
    this.isOpenPartnerType = false;
  }

  onSelectPartnerType(key: string, value: string) {
    this.onCloseSelectPartnerType();
    this.form.partnerArea = value;
    this.form.consolidators = "";
    this.partnerType = value;
    PartnerController.getConsolidatorsByCity({
      search: "",
      page: 1,
      limit: 10,
      cityCode: this.cityCode === undefined ? "" : this.cityCode,
      type: this.partnerType === "" ? "" : this.partnerType,
      status: this.partnerStatus
    });
  }

  formatLongLat(value: string) {
    return value.replace(/[^0-9+-.]+/g, "").replace(",", "");
  }

  formatCommission(value: string) {
    return formatInputFloat(value, 2);
  }

  errorCaptionCommision = "";
  validateCommision(value: string) {
    value = value.replace(/,/g, ".");
    if (Number(value) < 0) {
      this.error.commision = true;
      this.errorCaptionCommision = "Komisi tidak boleh nol/kosong";
    } else if (Number(value) > 100) {
      this.error.commision = true;
      this.errorCaptionCommision = "Komisi tidak boleh lebih dari 100%";
    } else {
      this.error.commision = false;
    }
  }

  // phone
  formatNumber(value: string) {
    return value.replace(/[\D]+/g, "");
  }

  validatePhone(value: string) {
    this.error.phone = !/^\d+$/.test(value);
  }

  validateContactPhone(index: number) {
    this.form.contactPhones[index].error = !/^\d+$/.test(
      this.form.contactPhones[index].no
    );
  }

  get countryCode() {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.account_type_detail?.countryCode;
    return getPhoneDisplayCode(countryCode);
  }

  initPhoneCode() {
    this.setPhoneCodeNumber(this.countryCode);
    this.setContactPhoneCodeNumber(this.countryCode, 0);
  }

  phoneNumberCode = "";

  setPhoneNumber(val: string) {
    this.form.phone = val;
    this.error.error = !/^\d+$/.test(val);
  }

  setPhoneCodeNumber(val: string) {
    this.phoneNumberCode = val;
  }

  setContactPhoneNumber(val: string, index: number) {
    this.form.contactPhones[index].no = val;
    this.form.contactPhones[index].error = !/^\d+$/.test(
      this.form.contactPhones[index].no
    );
  }

  setContactPhoneCodeNumber(val: string, index: number) {
    this.form.contactPhones[index].code = val;
  }

  addPhone() {
    if (this.form.contactPhones.length > 2) {
      return;
    }

    this.form.contactPhones.push({
      no: "",
      code: this.countryCode,
      error: false,
      message: "partnerManagement.error.phoneInvalid"
    });
  }

  removePhone(index: number) {
    this.form.contactPhones.splice(index, 1);
  }

  get isMaxContactPhone() {
    return this.form.contactPhones.length < 3;
  }

  // npwp
  formatTax(value: string) {
    if (this.districtFieldRules.applyNpwpMask) {
      return formattedNPWP(value.replace(/[\D]+/g, ""));
    }
    return formatTaxIdInput(value, this.districtFieldRules);
  }

  validateTaxNumber(value: string) {
    if (this.districtFieldRules.applyNpwpMask) {
      this.error.taxNumber = !/[0-9-.]+/.test(value);
      if (value.length < 20) {
        this.error.taxNumber = true;
      }
      return;
    }
    this.error.taxNumber = !validateTaxIdValue(value, this.districtFieldRules);
  }

  // bank
  get bankList() {
    return PartnerController.partnerBank.map(bank => {
      return { name: bank.bankName, value: bank.bankCode };
    });
  }
  fetchListBank() {
    PartnerController.getListPartnerBank();
  }
  get loadingBank() {
    return PartnerController.isLoadingBank;
  }

  // email
  validateEmail(value: string) {
    this.error.contactEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  validateEmailBank(value: string) {
    this.error.bankEmail = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // account bank no
  validateAccountNo(value: string) {
    this.error.accountBankNo = !/^\d+$/.test(value);
  }

  isPartnerAreaDeliveryValid(partnerAreaDelivery: any) {
    if (!this.isShowAreaDeliverySection) {
      return true;
    }
    if (!partnerAreaDelivery || !Array.isArray(partnerAreaDelivery) || partnerAreaDelivery.length === 0) {
      return false;
    }
    
    return partnerAreaDelivery.every((item: any) => 
      item?.cityCode && 
      item?.cityCode !== '' && 
      item?.district && 
      Array.isArray(item.district) && 
      item.district.length > 0 &&
      item.district.every((district: any) => district?.value || district?.code)
    );
  };

  // validator
  get isFormValid() {
    if (
      this.$route.meta.form === "consolidator" &&
      this.form.consolidatorName &&
      this.form.consolidatorAddress &&
      this.form.districts?.id &&
      this.form.phone &&
      this.form.contactName &&
      this.form.contactLevel &&
      this.form.contactEmail &&
      this.form.contactPhones[0].no &&
      this.form.startDate &&
      this.form.endDate &&
      this.form.latitude &&
      this.form.longitude &&
      !this.error.error &&
      !this.error.taxNumber &&
      !this.error.contactEmail &&
      this.isPartnerAreaDeliveryValid(this.form.partnerAreaDelivery)
    ) {
      return false;
    } else if (
      this.$route.meta.form === "sub-consolidator" &&
      this.form.consolidatorName &&
      this.form.consolidatorAddress &&
      this.form.consolidators?.id &&
      this.form.districts?.id &&
      this.form.contactName &&
      this.form.contactLevel &&
      this.form.contactEmail &&
      this.form.contactPhones[0].no &&
      this.form.startDate &&
      this.form.endDate &&
      this.form.latitude &&
      this.form.longitude &&
      !this.error.contactEmail
    ) {
      return false;
    } else
      return !(
        this.$route.meta.form === "pos" &&
        this.form.consolidatorName &&
        this.form.consolidatorAddress &&
        this.form.districts?.id &&
        this.form.contactName &&
        this.form.contactLevel &&
        this.form.contactEmail &&
        this.form.contactPhones[0].no &&
        this.form.startDate &&
        this.form.endDate &&
        this.form.partnerArea &&
        this.form.consolidators?.id &&
        this.form.latitude &&
        this.form.longitude &&
        !this.error.contactEmail &&
        this.validateReferralCode &&
        this.form.typePos &&
        !this.isParentPosDipickup &&
        !this.isParentPos &&
        !this.validateFiles &&
        !this.isLoadingUpload
      );
  }

  get validateFiles() {
    const newFiles = this.form.partnerPosAttachFiles?.filter((item: string) => item);
    return newFiles?.length < 3
  }

  errorCaptionKecamatanKota = "";
  errorKecamatanKota = false;
  get errorMessageAdd() {
    if (
      PartnerController.errorMessageAdd ===
      "Sub Console di district ini sudah ada"
    ) {
      this.errorCaptionKecamatanKota = "Kecamatan Sudah Tersedia";
      this.errorKecamatanKota = true;
      return "Kecamatan kota yang Anda pilih sudah tersedia untuk Sub Consolidator lain.";
    }
    return PartnerController.errorMessageAdd;
  }

  checkReferralCodeResult = true;
  onChangeReferralCode = debounce(async (value: string) => {
    if (!value) {
      this.checkReferralCodeResult = true;
      return;
    }
    if (value.length < 6 || value.length > 6) {
      this.checkReferralCodeResult = false;
      return;
    }
    this.checkReferralCodeResult = await PartnerController.checkReferralCode(
      this.form.referralCode
    );
  }, 500);
  get validateReferralCode() {
    if (!this.form.referralCode) return true;
    return this.checkReferralCodeResult;
  }

  onCheckedCODDeliveryPartner(value: any) {
    this.form.partnerIsCodDelivery = value;
  }

  onCheckedCODBookingPartner(value: any) {
    this.form.partnerIsCodBooking = value;
  }

  onCheckedPartnerIsPCU(value: any) {
    this.form.partnerIsPcu = value;
  }

  onCheckedPartnerIsAllowBookVippack(value: any) {
    this.form.partnerIsAllowBookVippack = value
  }

  onCheckedPartnerIsPosOwnSales(value: any) {
    this.form.partnerIsPosOwnSales = value
  }

  // tipe pos
  openTypePos = false;
  typePos = [
    { name: "Pilih tipe", value: "" },
    { name: "POS Parent", value: "parent" },
    { name: "POS Child", value: "branch" },
    { name: "POS Dipickup", value: "pickup" }
  ];

  onChangeTypePos(name: string, val: string) {
    this.form.typePos = val;
    this.form.parentPos = "";
    this.form.subconsolidators = "";
    this.openTypePos = false;
  }

  filterPartnerPosReverseJourney = debounce((search: string) => {
    PosController.getPosList(
      new RequestListPartner({
        page: 1,
        limit: 10,
        type: "pos",
        cityCode: this.form.districts?.cityCode,
        search: search,
        posType: "parent",
        contractStatus: "active"
      })
    );
  }, 250);

  get posReverseJourney() {
    return PosController.posList.data?.map((data: PosData) => ({
      id: data.id,
      name: `${data.code}-${data.name}`
    }));
  }

  // parent pos
  get isParentPos() {
    if (this.form.typePos) {
      return (
        this.form.typePos === "branch" &&
        !this.form.parentPos?.id &&
        !this.form.branchCommission
      );
    }

    return true;
  }

  get isParentPosDipickup() {
    if (this.form.typePos) {
      return (
        this.form.typePos === "pickup" &&
        !this.form.parentPos?.id 
      );
    }

    return true;
  }

  filterParentPos = debounce((search: string) => {
    PosController.getPosList(
      new RequestListPartner({
        page: 1,
        limit: 10,
        type: "pos",
        cityCode: this.form.districts?.cityCode,
        search: search,
        posType: "parent"
      })
    );
  }, 250);

  get isLoadingParentPos() {
    return PosController.isLoading;
  }

  get isLoadingSubPos() {
    return PosController.isLoading;
  }

  get parentPos() {
    return PosController.posList.data;
  }

  updateFiles(files: string[]) {
    this.form.partnerPosAttachFiles = files;
  }

  isLoadingUpload = false;
  setLoadingUpload(status: boolean) {
    this.isLoadingUpload = status;
  }

  formatDebitBalance(value: string) {
    return formatInputMoney(value.replace(/[\D]+/g, ""));
  }

  get isFormTypePos() {
    return this.formType === 'pos';
  }

  get showAddOrDeleteBankAccountButton() {
    return FlagsPermissionPartnerManagement.show_hide_bank_section.isEnabled();
  }
}
